import { IconProps } from '../';

const defaultSize = 48;

export const SuccessIcon = ({ size, className }: IconProps) => {
  const sizeToUse = size || defaultSize;
  return (
    <svg
      className={className}
      height={sizeToUse}
      width={sizeToUse}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M16 2.66669C8.63996 2.66669 2.66663 8.64002 2.66663 16C2.66663 23.36 8.63996 29.3334 16 29.3334C23.36 29.3334 29.3333 23.36 29.3333 16C29.3333 8.64002 23.36 2.66669 16 2.66669ZM12.3866 21.72L7.59996 16.9334C7.07996 16.4134 7.07996 15.5734 7.59996 15.0534C8.11996 14.5334 8.95996 14.5334 9.47996 15.0534L13.3333 18.8934L22.5066 9.72002C23.0266 9.20002 23.8666 9.20002 24.3866 9.72002C24.9066 10.24 24.9066 11.08 24.3866 11.6L14.2666 21.72C13.76 22.24 12.9066 22.24 12.3866 21.72Z"
        fill="#008000"
      />
    </svg>
  );
};
